((): void => {
  if (!import.meta.env.PUBLIC_USER_API_BASE_URL) {
    throw new Error(
      'Environment variable [PUBLIC_USER_API_BASE_URL] is not set.'
    );
  }
})();

const USER_API_BASE_URL = import.meta.env.PUBLIC_USER_API_BASE_URL;

export { USER_API_BASE_URL };
